export default "__VITE_ASSET__d4b42927__"